import Rx from 'rxjs/Rx';

import { makePaymentOptionsViewDetails } from '../../../../shared/models/payment-options-view.model';
import { makePaymentOptions } from '../../../../shared/models/payment-option.model';

class WithdrawalStore {
  constructor(TransactionApiService, StorageService, SessionService) {
    'ngInject';

    this.TransactionApiService = TransactionApiService;
    this.StorageService = StorageService;
    this.SessionService = SessionService;
  }

  /**
   * @returns {Observable}
   */
  getWithdrawDetails() {
    let details$ = Rx.Observable.fromPromise(this.TransactionApiService.withdrawDetails());

    return details$.map((details) => {
      return {
        paymentOptionsViewDetails: makePaymentOptionsViewDetails(details.paymentOptionsDisplay),
        customerProducts: details.customerProducts,
        paymentOptions: makePaymentOptions(details.paymentOptions)
      };
    });
  }

  getPaymentOptions() {
    return this.TransactionApiService.withdrawDetails().then(details => {
        return makePaymentOptions(details.paymentOptions)
    });
  }

  /**
   * @returns {Observable}
   */
  getCustomerProducts() {
    return this.getWithdrawDetails().map(details => details.customerProducts);
  }

  /**
   * @returns {Observable}
   */
  getCurrency() {
    return this.SessionService.session.map(session => session ? session.currency : null);
  }

  withdraw(payload) {
    return this.TransactionApiService.withdraw(payload);
  }

  getStatus() {
    return this.TransactionApiService.condition();
  }
}

export default WithdrawalStore;



// WEBPACK FOOTER //
// ./client/app/pages/customer/withdrawal/service/withdrawal.store.js